module.exports = __webpack_public_path__ + "images/casino-royale-bad8d35c4a164a5e3faae470b63f43c8.png";